import React, { useState, useMemo } from "react";
import { Carousel, CarouselItem } from "reactstrap";

const GrantCarousel = ({ filteredResources }) => {
  const grantCards = filteredResources || [];
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === grantCards.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === 0 ? grantCards.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const slides = grantCards?.map((card) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={card?.id}
      >
        <div style={styles.cardContainer}>
          <div style={styles.iconContainer}>
            <span style={styles.icon}>🎁</span>
          </div>
          <h4 style={styles.title}>{card?.resourceName}</h4>
          <div style={styles.balanceContainer}>
            <span style={styles.balance}>{card?.remainingBalance}</span>
            <span style={styles.uom}> {card?.uom}</span>
          </div>
          <p style={styles.description}>{"Available Balance"}</p>
          {/* {card.validity && card.validity !== '-' && (
            <p style={styles.validity}>Valid till: {card.validity}</p>
          )} */}
        </div>
      </CarouselItem>
    );
  });

  return (
    <div style={styles.grantContainer}>
      {filteredResources?.length > 0 ? (
        <>
          <div className="section-title mb-0">Grant Details</div>
          <div style={styles.carouselWrapper}>
            <Carousel
              activeIndex={activeIndex}
              next={next}
              previous={previous}
              interval={false}
              style={styles.carousel}
            >
              {slides}
              <button
                onClick={previous}
                style={styles.controlPrev}
                aria-label="Previous"
              >
                <span style={styles.arrow}>‹</span>
              </button>
              <button
                onClick={next}
                style={styles.controlNext}
                aria-label="Next"
              >
                <span style={styles.arrow}>›</span>
              </button>
            </Carousel>
            <div style={styles.customIndicators}>
              {grantCards.map((card, idx) => (
                <button
                  key={idx}
                  onClick={() => goToIndex(idx)}
                  style={{
                    ...styles.dot,
                    ...(idx === activeIndex ? styles.dotActive : {}),
                  }}
                  aria-label={`Go to slide ${idx + 1}`}
                />
              ))}
            </div>
          </div>
        </>
      ) : (
        <div
          className="text-center d-flex justify-content-center align-items-center"
          style={{ height: "329px" }}
        >
          <p className="fw-bold fs-5 balance-heading-color m-0">{" No Data"}</p>
        </div>
      )}
    </div>
  );
};

const styles = {
  grantContainer: {
    height: "330px",
    backgroundColor: "#F8FAFC",
    border: "1px solid #E2E8F0",
    borderRadius: "10px",
    // maxWidth: '1000px',
    // margin: '0 auto',
    padding: "16px",
    // fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  carouselWrapper: {
    position: "relative",
    borderRadius: "12px",
    margin: "15px 30px",
    // padding: '40px 20px',
    // boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
  },

  cardContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px 24px",
    backgroundColor: "#FFF5F5",
    borderRadius: "12px",
    // minHeight: '350px',
  },
  iconContainer: {
    marginBottom: "3px",
  },
  icon: {
    fontSize: "36px",
  },
  title: {
    fontSize: "16px",
    fontWeight: "400",
    marginBottom: "3px",
    color: "#0F172B",
  },
  balanceContainer: {
    marginBottom: "3px",
  },
  balance: {
    fontSize: "36px",
    fontWeight: "400",
    color: "#FD7545",
  },
  uom: {
    fontSize: "16px",
    fontWeight: "400",
    color: "#45556C",
  },
  description: {
    fontSize: "14px",
    color: "#62748E",
    marginTop: "10px",
    marginBottom: "5px",
  },
  //   validity: {
  //     fontSize: '14px',
  //     color: '#9BADC2',
  //     marginTop: '5px',
  //   },
  controlPrev: {
    position: "absolute",
    left: "-20px",
    top: "45%",
    transform: "translateY(-50%)",
    width: "36px",
    height: "36px",
    borderRadius: "10px",
    border: "1px solid #E5E5E5",
    backgroundColor: "#fff",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 10,
    transition: "all 0.2s ease",
  },
  controlNext: {
    position: "absolute",
    right: "-20px",
    top: "45%",
    transform: "translateY(-50%)",
    width: "36px",
    height: "36px",
    borderRadius: "10px",
    border: "1px solid #E5E5E5",
    backgroundColor: "#fff",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 10,
    transition: "all 0.2s ease",
  },
  arrow: {
    fontSize: "20px",
    color: "#0A0A0A",
    lineHeight: 1,
    userSelect: "none",
  },
  customIndicators: {
    display: "flex",
    justifyContent: "center",
    gap: "8px",
    marginTop: "30px",
  },
  dot: {
    width: "10px",
    height: "8px",
    borderRadius: "4px",
    border: "none",
    backgroundColor: "#E5E5E5",
    cursor: "pointer",
    padding: 0,
    transition: "all 0.3s ease",
  },
  dotActive: {
    backgroundColor: "#FF6B35",
    width: "20px",
  },
};

export default GrantCarousel;
